import Svg, {Path} from 'react-native-svg';

interface IArrowStep4Props {
  color?: string;
}

function ArrowStep5(props: IArrowStep4Props) {
  return (
    <Svg width={93} height={122} viewBox="0 0 93 122" fill="none" {...props}>
      <Path
        d="M3.725 117.614c14.966-9.311 27.963-21.305 38.151-35.082C52.158 68.665 59.728 53.1 63.941 36.819c2.37-9.114 3.686-18.468 3.76-27.793.032-2.816 4.803-2.924 4.771-.108-.275 17.334-4.373 34.492-11.55 50.576-7.18 15.908-17.632 30.659-30.521 43.177-7.287 7.027-15.354 13.279-24.108 18.755-2.64 1.467-5.11-2.259-2.568-3.812z"
        fill="#fff"
      />
      <Path
        d="M86.229 38.864c-2.102-12.707-8.2-24.883-17.394-34.615 1.328-.382 2.657-.676 3.985-1.058-3.674 10.551-8.983 20.611-15.842 29.65-.741.985-2.067 1.455-3.226.865-1.061-.503-1.668-1.985-.926-2.97 6.578-8.769 11.801-18.387 15.389-28.584.54-1.42 2.713-2.436 3.985-1.058C82.178 11.775 88.679 24.822 91 38.844c.217 1.138-1.19 2.226-2.335 2.252-1.433-.056-2.218-1.006-2.437-2.232z"
        fill="#fff"
      />
    </Svg>
  );
}

export default ArrowStep5;
